<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-header">
        <AccettazioneSsnImpegnativaModalComponent @onModificaImpegnativa="onModificaImpegnativa" @onAggiungiImpegnativa="onAggiungiImpegnativa" ref="cmpAccettazioneSsnImpegnativaModalComponent" :isEdit="true" :idAccettazione="idAccettazione" />
      </div>
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <span class="sa-flexbox-body-title">Impegnative</span>
          <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaRicetta" class="mb-2">
            <font-awesome-icon icon="plus"> </font-awesome-icon>
            Aggiungi
          </b-button>
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="ricette" :fields="headersImpegnative" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template v-slot:cell(tipologia)="row">
              <span style="font-weight: 700; margin-right: 3px">{{ row.item.tipologia }}</span>
            </template>
            <template v-slot:cell(nre)="row">
              <span style="font-weight: 700; margin-right: 3px">{{ row.item.codiceBar1 }}{{ row.item.codiceBar2 }}</span>
            </template>
            <template v-slot:cell(prestazioni)="row">
              <span style="font-weight: 700; margin-right: 3px">
                {{ row.item.prestazioni ? row.item.prestazioni.length : 0 }}
              </span>
            </template>
            <template v-slot:cell(statoAttuale)="row">
              <span style="font-weight: 500; margin-right: 1px">{{ row.item.statoAttuale }}</span>
            </template>
            <template v-slot:cell(actions)="row">
              <b-container class="bv-example-row">
                <b-button size="sm" v-b-tooltip.hover title="Modifica Ricetta" :disabled="row.item.statoAttuale != 'PRESA IN CARICO'" variant="outline-primary" @click="onClickModificaRicetta(row)">
                  <b-icon icon="pencil"></b-icon>
                </b-button>
                <b-button size="sm" v-b-tooltip.hover title="Visualizza Prestazioni" variant="outline-primary" @click="onClickVisualizzaPrestazioni(row)">
                  <font-awesome-icon :icon="'eye'" />
                </b-button>
                <b-button size="sm" v-b-tooltip.hover title="Elimina Ricetta" variant="outline-danger" @click="onClickRimuoviRicetta(row)">
                  <font-awesome-icon :icon="'trash'" />
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
      </div>
      <b-modal ref="mdlPrestazioni" title="Prestazioni">
        <b-row v-if="ricettaSelezionata.prestazioni" style="display: flex; justify-content: center">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px"> <span class="font-weight-bold" style="font-size: large"> Appuntamento/i Selezionato/i</span> <br /> </b-col>
          <b-col v-for="(selezione, index) in ricettaSelezionata.prestazioni" :key="index" cols="auto" style="margin: 1px; text-align: center">
            <b-card class="ft-card" style="height: 100%; width: 100%" v-for="appuntamento in selezione.appuntamenti" :key="appuntamento.id">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: medium">{{ appuntamento.titolo }}</div>
                <div class="font-weight-bold" style="font-size: small">{{ appuntamento.descrizionePrestazione }}</div>
                <div class="font-weight-bold" style="font-size: large">{{ appuntamento.dataRiferimento }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ getOrario(appuntamento.dataOraInizio) }} - {{ getOrario(appuntamento.dataOraFine) }}</div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<script>
// import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaModalComponent from "./AccettazioneSsnImpegnativaModalComponent1.vue";
import moment from "moment";
// import axios from "axios";
// DatePicker
export default {
  components: { AccettazioneSsnImpegnativaModalComponent },
  mixins: [UtilityMixin],
  props: {
    idAccettazione: {
      type: String,
      required: true,
      default: () => {
        return null;
      },
    },
  },

  data() {
    return {
      ricette: [],
      localData: {
        accettazioneAnagrafica: {
          codiceFiscalePaziente: "",
        },
      },
      ricettaSelezionata: {
        prestazioni: [],
      },
      perPage: 10,
      currentPage: 1,
      listKey: 0,
      rows: 0,
      headersImpegnative: [
        {
          label: "Tipologia",
          key: "tipologiaRicetta",
        },
        {
          label: "Priorità",
          key: "classePriorita",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "Stato Ricetta",
          key: "statoAttuale",
        },
        {
          label: "Quantita",
          key: "prestazioni",
        },
        {
          label: "",
          key: "actions",
          tdClass: "text-right",
        },
      ],
      rowRicettaDaModificare: null,
    };
  },

  computed: {},
  mounted() {
    console.log(this.idAccettazione);
  },

  watch: {},
  methods: {
    init(jsonData) {
      if (this.idAccettazione != "-1") {
        this.localData = jsonData;
        this.loadRicette();
      }
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    getDataSistoFormat(data) {
      let date = new Date(data);
      return moment(date).format("DD-MM-YYYY");
    },
    loadRicette() {
      if (this.idAccettazione) {
        UtilityMixin.methods.loadDataResources("/accettazionericette", { idAccettazione: this.idAccettazione }, this.loadRicetteSuccess, this.loadRicetteError);
      }
    },
    loadRicetteSuccess(response) {
      this.ricette = response.data.data.list;
      this.rows = response.data.data.recordsNumber;
    },
    loadRicetteError(err) {
      err;
    },
    getLocalData() {
      return this.localData;
    },
    onClickNuovaRicetta() {
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.init(this.localData);
    },
    onClickModificaRicetta(row) {
      console.log(row);
      this.rowRicettaDaModificare = row;
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.setRicettaModificare(this.rowRicettaDaModificare);
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.show();
    },
    onClickStorico(row) {
      console.log(row);
      row.toggleDetails();
    },
    onClickRimuoviRicetta(row) {
      this.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo record non sarà più recuperabile  '" + row.item.codiceBar1 + " " + row.item.codiceBar2 + " ?", {
          title: "Eliminazione Ricetta",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deletePopRicetta(row);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deletePopRicetta(row) {
      if (row.item.id) {
        this.deleteRicetta(row.item.id);
      } else {
        this.ricette.splice(row.index, 1);
      }
    },
    deleteRicetta(id) {
      console.log(id);
    },
    onAggiungiImpegnativa(ricetta) {
      this.ricette.push(JSON.parse(JSON.stringify(ricetta)));
      this.salvaRicetta(ricetta);
    },
    salvaRicetta(ricetta) {
      ricetta.idAccettazione = this.idAccettazione;
      UtilityMixin.methods.restCallPost(process.env.VUE_APP_PATH_API + "/accettazionericette", ricetta, this.onSalvaRicettaSuccess, this.onSalvaRicettaError);
    },
    onSalvaRicettaSuccess(response) {
      response;
    },
    onSalvaRicettaError(err) {
      err;
    },
    onModificaImpegnativa(ricetta, index) {
      let newItem = JSON.parse(JSON.stringify(ricetta));
      if (ricetta.id) {
        this.modificaRicetta(ricetta);
      } else {
        this.ricette.splice(index, 1, newItem);
      }
    },
    modificaRicetta(ricetta) {
      ricetta.idAccettazione = this.idAccettazione;
      UtilityMixin.methods.restCallPut(process.env.VUE_APP_PATH_API + "/accettazionericette/" + ricetta.id, ricetta, this.onModificaRicettaSuccess, this.onModificaRicettaError);
    },
    onModificaRicettaSuccess(response) {
      response;
    },
    onModificaRicettaError(err) {
      err;
    },
    onClickVisualizzaPrestazioni(row) {
      this.ricettaSelezionata = row.item;
      this.$refs.mdlPrestazioni.show();
    },
  },
};
</script>

<style scoped>
.ft-card {
  border: 1px solid #b6b5b5 !important;
  border-radius: 12px;
  padding: 2px;
  transition: all 0.1s linear;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  cursor: pointer;
}
.ft-card .card-body {
  padding: 5px !important;
}
.ft-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}
.ftActiveClass,
.ftActiveClass:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 2px solid #00a3ff !important;
  border-color: #00a3ff !important;
}
</style>
